export const SATURDAY_DEFAULT_IMAGE_URL =
    "https://braze-images.com/appboy/communication/assets/image_assets/images/6a2c4c639ec6dd0083d17c2a/original.png?1781288034";

export enum EModulesArticleHeader {
    BLOG = "Blog",
    NEWSLETTER = "Newsletter",
    PRESENTATION_EXPRESSWAY = "Presentation Expressway",
}
